export default __webpack_public_path__ + "static/media/Rocket-Cake.d193206d.jpg";